var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoConnectionIndicatorWifi = function SvgIcoConnectionIndicatorWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 20,
    fill: "none",
    viewBox: "0 0 64 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 63,
    height: 19,
    x: 0.5,
    y: 0.5,
    stroke: "#EEE",
    opacity: 0.5,
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M15.074 14.614a.969.969 0 1 1-1.938 0 .969.969 0 0 1 1.938 0m5.794-7.278a10.666 10.666 0 0 0-13.528 0 .727.727 0 0 0 .923 1.124 9.21 9.21 0 0 1 11.682 0 .727.727 0 0 0 .923-1.124M18.92 9.5a7.76 7.76 0 0 0-9.63 0 .727.727 0 0 0 .903 1.14 6.3 6.3 0 0 1 7.824 0 .727.727 0 0 0 .903-1.14m-1.962 2.161a4.85 4.85 0 0 0-5.706 0 .727.727 0 1 0 .857 1.176 3.39 3.39 0 0 1 3.992 0 .726.726 0 0 0 1.135-.417.73.73 0 0 0-.278-.759M27.313 14l-2.748-8.4h2.016l2.388 7.44H27.96l2.496-7.44h1.8l2.4 7.44h-.972l2.448-7.44h1.86L35.245 14h-2.088l-2.124-6.528h.552L29.4 14zm11.738 0V7.544h1.872V14zm.936-7.356q-.514 0-.84-.3a.97.97 0 0 1-.323-.744q0-.444.324-.744.322-.3.84-.3.515 0 .84.288a.9.9 0 0 1 .323.72q0 .468-.324.78-.31.3-.84.3m2.434 4.728v-1.5h3.396v1.5zm6.8-1.992h4.033v1.56h-4.032zm.145 4.62h-1.944V5.6h6.348v1.56h-4.404zm5.588 0V7.544h1.872V14zm.936-7.356q-.516 0-.84-.3a.97.97 0 0 1-.324-.744q0-.444.324-.744t.84-.3.84.288a.9.9 0 0 1 .324.72q0 .468-.324.78-.312.3-.84.3"
  })));
};
export default SvgIcoConnectionIndicatorWifi;